module.exports = __webpack_public_path__ + "img/share_icon.eef9abf.png";